/**
 * `AutoSubmitForm` renders a POST `<form>` with hidden inputs and auto-submits
 * it on mount.
 *
 * Common usage:
 * - Payment gateway handoffs (e.g. 3DS challenges) where a form POST is
 *   required.
 */

import React, { useEffect, useRef } from 'react';

export type FormParam = {
  name: string;
  value: string;
};

type AutoSubmitFormProps = {
  actionUrl: string;
  params: FormParam[];
  target?: string;
};

const AutoSubmitForm = ({
  actionUrl,
  params,
  target
}: AutoSubmitFormProps): JSX.Element => {
  const formRef = useRef<HTMLFormElement>(null);

  useEffect(() => {
    if (formRef.current !== null) {
      formRef.current.submit();
    }
  }, []);

  return (
    <form
      ref={formRef}
      method='POST'
      action={actionUrl}
      target={target || '_self'}>
      {params.map((param) => (
        <input
          key={param.name}
          type='hidden'
          name={param.name}
          value={param.value}></input>
      ))}
    </form>
  );
};

export default AutoSubmitForm;
